<template>
  <div>
    <div class="option" v-for="op in options" :class="[op.option==rightoption ? 'checked' : '']">
      <span class="spot">{{op.option}}</span><span class="spot-con" v-html="op.content"></span>
      <img class="img" :src="op.image.url" v-if="op.image.url">
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
  export default {
    props: ['options', 'rightoption'],
    data() {
      return {}
    },
    created() {

    },
    methods: {},
  };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "./src/assets/scss/common/_mixin";

  .option {
    padding: $w $w;
    border-bottom: 1px/$ppr solid #E8E8E8;
    display: flex;
    display: -webkit-flex;
    flex-wrap: wrap;
    -webkit-flex-wrap: wrap;
    .spot {
      display: block;
      width: $w*2;
      height: $w*2;
      line-height: $w*2;
      text-align: center;
      border: 1px/$ppr solid #E8E8E8;
      border-radius: $w;
      margin-right: $w;
    }
    .spot-con {
      flex: 1;
      -webkit-flex: 1;
    }
  }

  .checked {
    color: #66CC22 !important;
    .spot {
      background-color: #66CC22 !important;
      border: 1px/$ppr solid #66CC22 !important;
      color: #fff;
    }
  }

  .option:last-child {
    //border:0!important;
  }
</style>
